import React, { useEffect, useContext } from "react";
import { Helmet } from "react-helmet-async";
import { ClientContext } from "graphql-hooks";
import { useNavigate } from "react-router-dom";

/*##########################################################################
## Function    : Logout
## Description : logout user
## Author      : RR
## Date        : 2022/03/12
##########################################################################*/
export default function AdminSignOut() {
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  useEffect(
    () => {
	    localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("role");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        client.removeHeader("Authorization");
      navigate(`/signin/`);
    },
    [localStorage]
  );

  /////////////////////////////////////////////////////////////////////
  return (
    <>
      <Helmet>
        <title>R3PLAY - Sign Out</title>
        <meta
          name="description"
          content="You’ve successfully signed out from your account"
        />
        <meta
          property="keywords"
          content="Logout, r3play sign out"
        />        
      </Helmet>

    <h2>
      You are logged out. You will be redirected to login page.
    </h2>
    </>
  );
}
